module.exports = __webpack_public_path__ + "img/mood-icon-7.bec640a2.svg";